function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.7998 12C7.7998 12.55 8.2498 13 8.7998 13H16.7998C17.3498 13 17.7998 12.55 17.7998 12C17.7998 11.45 17.3498 11 16.7998 11H8.7998C8.2498 11 7.7998 11.45 7.7998 12ZM12.7998 2C7.2798 2 2.7998 6.48 2.7998 12C2.7998 17.52 7.2798 22 12.7998 22C18.3198 22 22.7998 17.52 22.7998 12C22.7998 6.48 18.3198 2 12.7998 2ZM12.7998 20C8.3898 20 4.7998 16.41 4.7998 12C4.7998 7.59 8.3898 4 12.7998 4C17.2098 4 20.7998 7.59 20.7998 12C20.7998 16.41 17.2098 20 12.7998 20Z",
  fill: "currentColor"
});

function SvgMinusCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircle);
export default __webpack_public_path__ + "static/media/minus-circle.45a6f4bb.svg";
export { ForwardRef as ReactComponent };